import type { TWarehouseTaskStatus, TWarehouseTaskType } from 'api/swagger';
import { createStore } from './create-store';

export interface IWhTaskFilter {
  type?: TWarehouseTaskType;

  statuses?: TWarehouseTaskStatus[];

  warehouseId?: number[];

  arrivalDate?: {
    from: Date;
    to: Date;
  };

  departureDate?: {
    from: Date;
    to: Date;
  };

  clientId?: {
    value: number;
    label?: string;
  };

  userId?: number;
}

type TState = {
  search: string;
  filters?: IWhTaskFilter;
};

type TActions = {
  setSearch: (value: string) => void;
  setFilters: (value: IWhTaskFilter | undefined) => void;
};

export const useWhTaskFiltersStore = createStore<TState & TActions>(
  (set) => ({
    search: '',
    filters: undefined,
    setSearch: (search: string) => set((state) => ({ ...state, search })),
    setFilters: (filters: IWhTaskFilter | undefined) => set((state) => ({ ...state, filters })),
  }),
  'wh-task-filters-store',
);
